export const DND_MIME = 'application/x-fintegrate-dnd';

export const setDragData = (e, payload) => {
    e.dataTransfer.setData(DND_MIME, JSON.stringify(payload));
    e.dataTransfer.effectAllowed = 'move';
};

export const getDragData = (e) => {
    try {
        return JSON.parse(e.dataTransfer.getData(DND_MIME));
    } catch (err) {
        return null;
    }
};

export const hasDragData = (e) => Array.from(e.dataTransfer.types || []).includes(DND_MIME);

export const buildChildrenByParent = (folders) => {
    const map = {};
    (folders || []).forEach((folder) => {
        const key = folder.parent_folder_id ?? 'root';
        if (!map[key]) {
            map[key] = [];
        }
        map[key].push(folder);
    });
    return map;
};

export const getRootFolders = (folders) => (folders || []).filter((f) => !f.parent_folder_id);

export const buildFolderOptions = (folders, excludeId = null) => {
    const childrenByParent = buildChildrenByParent(folders);
    const result = [];

    const walk = (parentKey, depth) => {
        (childrenByParent[parentKey] || []).forEach((folder) => {
            if (excludeId !== null && String(folder.id) === String(excludeId)) {
                return;
            }
            result.push({ id: folder.id, name: folder.name, depth });
            walk(folder.id, depth + 1);
        });
    };

    walk('root', 0);
    return result;
};

export const getFolderChain = (folders, folderId) => {
    const byId = new Map((folders || []).map((folder) => [String(folder.id), folder]));
    const chain = [];
    let folder = byId.get(String(folderId));
    while (folder) {
        chain.unshift(folder);
        folder = byId.get(String(folder.parent_folder_id));
    }
    return chain;
};

export const getFlowFolder = (folders, flowId) => (folders || [])
    .find((f) => (f.flow_ids || []).some((id) => String(id) === String(flowId)));

export const getFlowFolderPath = (folders, flowId) => {
    const folder = getFlowFolder(folders, flowId);
    return folder ? getFolderChain(folders, folder.id).map((f) => f.name).join(' / ') : '';
};

export const countFoundFlows = (folders, flows) => (flows || []).reduce((counts, flow) => {
    const folder = getFlowFolder(folders, flow.id);
    const keys = folder ? getFolderChain(folders, folder.id).map((f) => f.id) : ['home'];
    keys.forEach((key) => { counts[key] = (counts[key] || 0) + 1; });
    return counts;
}, {});
